﻿
import { parseUrlArgsGS } from '../core/state/UrlParserGS';

interface ArgsDictionary {
    [name: string]: string;
}


export function redirect(url: string) { window.location.href = url; };
export function changeUrl(url: string, state: object = {}, title = '') { window.history.replaceState(state, title, url); };

export function parseUrlArgs(urlString: string): ArgsDictionary {
    try {
        return parseUrlArgsGS(urlString);
    } catch {
        throw new URIError('Cannot parse URL arguments: the URL or its path encoding is malformed.');
    }
}

export function getUrlArgs(): ArgsDictionary { return parseUrlArgs(window.location.href); }

export function getCookie(name: string): string | undefined
{
    const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    const value = matches?.[1];
    return value === undefined ? undefined : decodeURIComponent(value);
}

export function setCookie(name: string, value: string, options: any = {})
{

    let cacheOptions = {
        path: '/',            
        ...options
    };

    if (cacheOptions.expires instanceof Date) { cacheOptions.expires = cacheOptions.expires.toUTCString(); }
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in cacheOptions) {
        updatedCookie += "; " + optionKey;
        let optionValue = cacheOptions[optionKey];
        if (optionValue !== true) { updatedCookie += "=" + optionValue; }
    }
    document.cookie = updatedCookie;
}
    
export function deleteCookie(name: string)
{
    setCookie(name, "", { 'max-age': -1 })
}
